import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AmplifyConfigService {

  configure(userPoolId: string, userPoolClientId: string, identityPoolId: string): void {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId,
          userPoolClientId,
          identityPoolId
        }
      },
      API: {
        GraphQL: {
          endpoint: 'https://xug4ifclpfdvbmagbnxj6tr6he.appsync-api.us-east-1.amazonaws.com/graphql',
          region: 'us-east-1',
          defaultAuthMode: 'userPool'
        }
      }
    }, {
      API: {
        GraphQL: {
          headers: async () => ({
            'Referrer-Policy': 'no-referrer',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache'
          })
        }
      }
    });
  }
}